import { Component, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js'
import { MarketService } from 'src/app/shared/services/market.service';
import { Auth } from 'aws-amplify';
import { SponsorshipRequestService } from 'src/app/shared/services/sponsorship-request.service';
import { ValuationRequestService } from 'src/app/shared/services/valuations-request.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  propertiesNumber: any;
  valRequestsNumber: any;
  sponsorshipRequestsNumber: any;
  owner: any;
  isLoading: boolean = false;

  constructor(
    private marketService: MarketService,
    private sponsorshipRequestService: SponsorshipRequestService, 
    private ValuationRequestsService: ValuationRequestService
  ) { 
    this.getCurrentAuthenticatedUser();
  }

  ngOnInit(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.getProperties();
      this.getSponsorshopReq();
      this.getAllValuationRequests();
      this.isLoading = false;
    }, 1500);
  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  getProperties() {
    this.marketService.getProperties(this.owner).subscribe((data) => {
      this.propertiesNumber = data.length;
    }, (error) => {
      console.log("err:", error);
    });

  }

  getSponsorshopReq() {
    this.sponsorshipRequestService.getSponsorshipRequestByStatus(this.owner).subscribe((data) =>{
      this.sponsorshipRequestsNumber = data.length;
    }, (error) =>{
      console.log("Error", error);
    });
  }

  getAllValuationRequests() {
    this.ValuationRequestsService.getAllValuationRequestsByStatus(this.owner).subscribe((data) =>{
      this.valRequestsNumber = data.length;
    }, (error) =>{
      console.log("Error", error);
      this.isLoading = false;
      
    });
  }

}
